// extracted by mini-css-extract-plugin
export default {"title":"editsellerinvoicepopup_title__opvJ9","popup":"editsellerinvoicepopup_popup__pTnlT","header":"editsellerinvoicepopup_header__7vjzP","btn":"editsellerinvoicepopup_btn__U+nip"};